import { CustomAppLayout } from '../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
import { useGlobalState } from '../../../context/GlobalStateContext';
import { useRouter } from '../../router';
const _preserve = React.version;


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Box, Button, Flashbar, FlashbarProps, FormField, Input, Link, Modal, SpaceBetween, SplitPanel, Table, Toggle } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { formatRut } from '@fdograph/rut-utilities';
import DPModal from '../../../../components/DPModal';
import BadgeUserType from '../../../../components/extras/BadgeUserType';
import Favorites from '../../../../components/extras/Favorites';
import UserAvatar from '../../../../components/extras/UserAvatar';
import SelectCharges from '../../../../components/selects/SelectCharges';
import SelectGroup from '../../../../components/selects/selectGroups';
import SelectUserType from '../../../../components/selects/selectUserTypes';
import { fetchWithWatch } from '../../../../hooks/fetchWithWatch';
import { ItemUser } from '../../../../resources/types';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, formatPhone, getCookie, getUrlVersion, isValidPhone, setData, setLoading } from '../../../commons/functions';
import { saveMasters } from './user.add';



export const MastersUsersPage = () => {

    const { data, menu } = useGlobalState();

    const [messagesModal, setMessagesModal] = useState<FlashbarProps.MessageDefinition[]>([]);
    useGlobalState();
    const { navigate } = useRouter();



    const [newUser, setNewUser] = useState<ItemUser>();
    const [users, setUsers] = useState<ItemUser[]>([]);
    const [user, setUser] = useState<ItemUser | null>(null);
    const [idCharges, setIdCharges] = useState<number[]>([]);
    const [idGroups, setIdGroups] = useState<number[]>([]);
    const [keyword, setKeyword] = useState<string>("");
    const [RUT, setRUT] = useState<string>("");
    const [modalAddUser, setModalAddUser] = useState(false);
    const [step1, setStep1] = useState(false);


    const handleImageUpdate = async () => {
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/resources/images/dgac?idUser=${user.idUser}`, {
                timeout: 60000,
                method: 'GET',
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            //addNotificationStatus(data, setData);
            console.log(data)
        } catch (error: any) {

        } finally { setLoading(false) }
    }
    const handleUserUpdate = async () => {
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/users/update',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({
                    idUser: user.idUser,
                    idUserType: user.idUserType,
                    masters: ["users"]
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            addNotificationStatus(dataWeb, setData);
            if (dataWeb.code == 0) {
                setUser(undefined)
                if (dataWeb.masters)
                    saveMasters(dataWeb.masters, data)
            }
        } catch (error: any) {

        } finally { setLoading(false) }
    }
    const handleSetActive = async (idUser: number, isActiveUser: number) => {
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/users/update',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({
                    idUser: idUser,
                    isActiveUser: isActiveUser,
                    masters: ["users"]
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            addNotificationStatus(dataWeb, setData);
            if (dataWeb.code == 0) {
                if (dataWeb.masters)
                    saveMasters(dataWeb.masters, data)
                setUser(undefined)
            }
        } catch (error: any) {

        } finally { setLoading(false) }
    }
    const handleSetDelete = async (idUser: number, isDeleteUser: number) => {
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/users/update',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({
                    idUser: idUser,
                    isDeleteUser: isDeleteUser,
                    masters: ["users"]
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            addNotificationStatus(dataWeb, setData);
            if (dataWeb.code == 0) {
                setUser(undefined)
                if (dataWeb.masters)
                    saveMasters(dataWeb.masters, data)
            }
        } catch (error: any) {

        } finally { setLoading(false) }
    }

    const handleCreateUser = async () => {
        try {
            setLoading(true)
            let usr = {
                ...newUser,
                phone1: newUser.phone1.replace(/\D/g, ''),
                idCharges: idCharges,
                idGroups: idGroups,
                welcome: true
            }
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/users/update',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({
                    ...usr,
                    masters: ["users"]
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                if (data.masters)
                    saveMasters(data.masters, data)
                if (data.user && data.user.idUser !== 0) {
                    setNewUser(undefined)
                    setUsers(undefined)
                    setMessagesModal([]);
                    setStep1(true);
                }
            } else {

            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);

        } finally { setLoading(false) }
    }
    const handleCheckRUT = async () => {
        try {
            setLoading(true)
            setMessagesModal([])
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/users/get.light',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({
                    phone1: newUser.phone1.replace(/\D/g, ''),
                    "columns": "idUser, displayName, RUT, phone1, email, isActiveUser, isDeleteUser"
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            if (data.code == 0) {
                if (data.user && data.user.idUser !== 0) {
                    setMessagesModal([{
                        type: 'info', content: `El usuario con móvil ${data.user.phone1} ya existe en el sistema. ID ${data.user.idUser}, ${data.user.displayName}`,
                        dismissible: true, onDismiss: () => { setMessagesModal([]) }
                    }]);
                } else {
                    setMessagesModal([]);
                    setStep1(true);
                }
            } else {

            }
        } catch (error: any) {

        } finally { setLoading(false) }
    }
    useEffect(() => {

    }, []);
    const handleSearchUser = async () => {
        try {
            setLoading(true)
            setUser(undefined)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/users/list',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({
                    keyw: keyword,
                    all: true,
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            if (data.code == 0) {
                setUsers(data.users);
            } else {

            }
        } catch (error: any) {

        } finally { setLoading(false) }
    }
    useEffect(() => {

    }, []);
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            splitPanelOpen={!!user}



            onSplitPanelToggle={(open) => {
                if (!open.detail.open) setUser(undefined)
            }}
            splitPanel=
            {user && (
                <SplitPanel hidePreferencesButton
                    header={`Usuario #${user.idUser ?? "----"}`}
                    headerDescription={`RUT: ${user.RUT ?? "----"}`}
                    closeBehavior="hide"
                >
                    <SpaceBetween size="s" >
                        <FormField label={"Tipo de usuario"}>
                            <SelectUserType
                                single
                                onSelect={(selected: number) => {
                                    setUser((prev) => ({
                                        ...prev,
                                        idUserType: selected
                                    }))

                                }}
                                value={user.idUserType ?? 0}

                            />
                        </FormField>
                        <Button variant='primary' onClick={() => {
                            handleUserUpdate();
                        }}>Actualizar Tipo</Button>

                        <UserAvatar idUser={user.idUser} size='small' cache />
                        <UserAvatar idUser={user.idUser} size='large' cache />
                        <Button variant='primary' onClick={() => {
                            handleImageUpdate();
                        }}>Actualizar Imagen</Button>
                    </SpaceBetween>

                </SplitPanel>
            )}
            content={
                < SpaceBetween size="s" >
                    <Header variant="h1" actions={<SpaceBetween size="s" direction='horizontal'><Button href='#masters/user.add' variant='normal'

                    >Agregar Usuario</Button><Favorites /></SpaceBetween>}>Usuarios</Header>
                    <Table
                        variant="embedded"
                        filter={<FormField label="Buscar usuario">

                            <Input
                                autoComplete="off"
                                placeholder="Ingrese término de búsqueda"
                                value={keyword}
                                onKeyDown={(event) => {
                                    if (event.detail.key === "Enter") {
                                        handleSearchUser()
                                    }
                                }}
                                onChange={event => {
                                    setKeyword(event.detail.value);
                                }}
                                ariaLabel="Buscar usuario"
                            />
                        </FormField>
                        }
                        columnDefinitions={[
                            {
                                id: 'idUser',
                                header: 'ID/RUT',
                                cell: item => <FormField label={item.RUT}>
                                    <Link onClick={() => {
                                        setUser(item)
                                    }}>
                                        {item.idUser}
                                    </Link>
                                </FormField>,
                                width: 140,
                            },
                            {
                                id: 'Nombre',
                                header: 'Nombre',
                                cell: item => <FormField label={item.lastName}>{item.name}</FormField>,
                            },
                            {
                                id: 'email',
                                header: 'Email/Fono',
                                cell: item => <FormField label={item.email}>{formatPhone(item.phone1)}</FormField>,
                            },
                            {
                                id: 'type',
                                header: 'Tipo',
                                cell: item => <BadgeUserType idUserType={item.idUserType} type="min" />,
                            },
                            {
                                id: 'active2',
                                header: 'Activo',
                                cell: item =>
                                    <Toggle
                                        onChange={({ detail }) => {
                                            setUsers(prevUsers =>
                                                prevUsers.map(u =>
                                                    u.idUser === item.idUser ? { ...u, isActiveUser: detail.checked ? 1 : 0 } : u
                                                )
                                            )
                                            handleSetActive(item.idUser, detail.checked ? 1 : 0)
                                        }}
                                        checked={item.isActiveUser === 1}
                                    />,
                            },
                            {
                                id: 'Eliminado',
                                header: 'Eliminado',
                                cell: item =>
                                    <Toggle
                                        onChange={({ detail }) => {
                                            setUsers(prevUsers =>
                                                prevUsers.map(u =>
                                                    u.idUser === item.idUser ? { ...u, isDeleteUser: detail.checked ? 1 : 0 } : u
                                                )
                                            )
                                            handleSetDelete(item.idUser, detail.checked ? 1 : 0)
                                        }}
                                        checked={item.isDeleteUser === 1}
                                    />
                            },

                        ]}
                        items={users}
                    />
                    {
                        newUser !== undefined && (
                            <Modal size="medium" onDismiss={() => setNewUser(undefined)} visible={newUser !== undefined} closeAriaLabel="Cerrar modal de agregar usuario" header="Agregar Usuario" footer={
                                <Box textAlign="right">
                                    <Button variant="link" onClick={() => setNewUser(undefined)}>Cerrar</Button>
                                    {step1 && (
                                        <Button variant='primary'
                                            disabled={!(newUser?.name && newUser?.lastName && newUser?.displayName && newUser?.email && newUser?.dateBirth && newUser?.dateMember && newUser.idUserType)}
                                            onClick={() => {
                                                handleCreateUser()
                                            }}
                                        >Crear usuario</Button>
                                    )}
                                </Box>}>
                                <SpaceBetween size="xs" direction='vertical'>
                                    <Flashbar items={messagesModal} />

                                    <SpaceBetween size="m" direction='horizontal'>
                                        <FormField label="Móvil">
                                            <Input placeholder="Ingrese teléfono del usuario" value={newUser.phone1}
                                                autoComplete="off"
                                                disabled={step1}
                                                onChange={(detail) => {
                                                    setNewUser((prev) => ({
                                                        ...prev,
                                                        phone1: formatPhone(detail.detail.value),
                                                    }));
                                                }}
                                                onBlur={() => {

                                                }}
                                            />
                                        </FormField>
                                        {!step1 && (
                                            <FormField label='&nbsp;'>
                                                <Button variant="primary" disabled={!isValidPhone(newUser.phone1)}
                                                    onClick={() => {
                                                        handleCheckRUT();
                                                    }}
                                                >Siguiente</Button>
                                            </FormField>
                                        )}
                                        {!!step1 && (
                                            <FormField label="Tipo de usuario">
                                                <SelectUserType single value={newUser.idUserType} onSelect={(selected) => {
                                                    setNewUser((prev) => ({
                                                        ...prev,
                                                        idUserType: selected
                                                    } as ItemUser));
                                                }} />

                                            </FormField>
                                        )}
                                    </SpaceBetween>
                                    {!!step1 && (
                                        <>
                                            <SpaceBetween size="xs" direction='horizontal'>
                                                <FormField label="Nombres">
                                                    <Input value={newUser?.name || ""}
                                                        autoComplete="off"
                                                        onChange={(detail) => {
                                                            setNewUser((prev) => ({
                                                                ...prev,
                                                                name: detail.detail.value.toUpperCase(),
                                                                displayName: setDisplayName(detail.detail.value, prev?.lastName || "")
                                                            } as ItemUser));
                                                        }}
                                                        onBlur={() => {
                                                            setNewUser((prev) => ({
                                                                ...prev,
                                                                name: newUser.name.trim(),
                                                                displayName: setDisplayName(newUser.name.trim(), prev?.lastName || "")
                                                            } as ItemUser));

                                                        }}
                                                    />
                                                </FormField>

                                                <FormField label="Apellidos">
                                                    <Input value={newUser?.lastName || ""}
                                                        autoComplete="off"
                                                        onChange={(detail) => {
                                                            setNewUser((prev) => ({
                                                                ...prev,
                                                                lastName: detail.detail.value.toUpperCase(),
                                                                displayName: setDisplayName(prev?.name || "", detail.detail.value)
                                                            } as ItemUser));
                                                        }}
                                                        onBlur={() => {
                                                            setNewUser((prev) => ({
                                                                ...prev,
                                                                lastName: newUser.lastName.trim(),
                                                                displayName: setDisplayName(prev?.name || "", newUser.lastName.trim())
                                                            } as ItemUser));

                                                        }}
                                                    />
                                                </FormField>
                                            </SpaceBetween>

                                            <FormField label="Nombre para mostrar">
                                                <Input value={newUser?.displayName || ""}
                                                    autoComplete="off"
                                                    onChange={(detail) => {
                                                        setNewUser((prev) => ({
                                                            ...prev,
                                                            displayName: detail.detail.value.toUpperCase()
                                                        } as ItemUser));
                                                    }}
                                                />
                                            </FormField>
                                            <SpaceBetween size="m" direction='horizontal'>
                                                <FormField label="RUT" constraintText={"*opcional"}>
                                                    <Input value={newUser?.RUT || ""}
                                                        autoComplete="off"
                                                        onBlur={() => {
                                                            setNewUser((prev) => ({
                                                                ...prev,
                                                                RUT: formatRut(newUser.RUT.replace(/[^0-9kK]/g, '').toUpperCase())
                                                            } as ItemUser));
                                                        }}
                                                        onChange={(detail) => {
                                                            setNewUser((prev) => ({
                                                                ...prev,
                                                                RUT: detail.detail.value.toUpperCase()
                                                            } as ItemUser));
                                                        }}
                                                    />
                                                </FormField>

                                            </SpaceBetween>
                                            <SpaceBetween size="m" direction='horizontal'>
                                                <FormField label="Email">
                                                    <Input value={newUser?.email || ""}
                                                        autoComplete="off"
                                                        onChange={(detail) => {
                                                            setNewUser((prev) => ({
                                                                ...prev,
                                                                email: detail.detail.value.toLocaleLowerCase()
                                                            } as ItemUser));
                                                        }}
                                                    />
                                                </FormField>
                                                <FormField label="Email alternativo" constraintText={"*opcional"}>
                                                    <Input value={newUser?.email2 || ""}
                                                        autoComplete="off"
                                                        onChange={(detail) => {
                                                            setNewUser((prev) => ({
                                                                ...prev,
                                                                email2: detail.detail.value.toLocaleLowerCase()
                                                            } as ItemUser));
                                                        }}
                                                    />
                                                </FormField>
                                            </SpaceBetween>
                                            <SpaceBetween size="m" direction='horizontal'>
                                                <FormField label="Fecha nacimiento">
                                                    <DPModal
                                                        date={newUser.dateBirth ?? ""}
                                                        end={new Date()}
                                                        yearPrev
                                                        yearNext
                                                        clear={false}
                                                        onConfirm={(date) => {
                                                            setNewUser((prev) => ({
                                                                ...prev,
                                                                dateBirth: date
                                                            } as ItemUser));
                                                        }} />
                                                </FormField>

                                                <FormField label="Fecha ingreso">
                                                    <DPModal

                                                        clear={false}
                                                        end={new Date()}
                                                        yearPrev
                                                        yearNext

                                                        date={newUser.dateMember ?? ""}
                                                        onConfirm={(date) => {
                                                            setNewUser((prev) => ({
                                                                ...prev,
                                                                dateMember: date
                                                            } as ItemUser));
                                                        }} />
                                                </FormField>
                                            </SpaceBetween>

                                            <SpaceBetween size="m" direction='vertical'>
                                                <FormField label="Cargos">
                                                    <SelectCharges
                                                        single={false}

                                                        onSelect={(selected: number[]) => {
                                                            setIdCharges(selected);
                                                        }}
                                                        value={idCharges || []}
                                                    />

                                                </FormField>
                                                <FormField label="Grupos">
                                                    <SelectGroup
                                                        single={false}

                                                        onSelect={(selected: number[]) => {
                                                            setIdGroups(selected);
                                                        }}
                                                        value={idGroups || []}
                                                    />

                                                </FormField>


                                            </SpaceBetween>
                                        </>

                                    )}
                                </SpaceBetween>
                            </Modal>
                        )
                    }
                </SpaceBetween >
            }
        />
    );
};

function setDisplayName(name: string, lastName: string): string {
    const firstNameParts = name.trim().split(/\s+/).filter(Boolean);
    const lastNameParts = lastName.trim().split(/\s+/).filter(Boolean);
    const firstName = firstNameParts.length > 0 ? firstNameParts[0] : ""; // "Felipe"
    const firstLastName = lastNameParts.length > 0 ? lastNameParts[0] : ""; // "Brito"
    const secondLastNameInitial = lastNameParts.length > 1 ? lastNameParts[1].charAt(0) : null; // "P"
    return `${firstName.toUpperCase()} ${firstLastName.toUpperCase()}`
}
